// ─────────────────────────────────────────────────────────────────
// Glass-i — Expense Entry grid columns (Stage 6B.7).
// ─────────────────────────────────────────────────────────────────

import { Tag } from 'antd';
import { formatINR } from '../../../../components/common/erp-grid';
import {
  EXPENSE_TYPE_LABEL, EXPENSE_TYPE_COLOR,
  STATUS_COLOR, STATUS_LABEL,
  PAYMENT_STATUS_LABEL, PAYMENT_STATUS_COLOR
} from './expenseEntryConstants';

function fmtDate(v) {
  return v ? String(v).slice(0, 10) : <span className="erp-grid__muted">—</span>;
}
function fmtTs(v) {
  if (!v) return <span className="erp-grid__muted">—</span>;
  const d = new Date(v);
  if (Number.isNaN(d.getTime())) return v;
  return <span>{d.toISOString().slice(0, 10)} {d.toISOString().slice(11, 16)}</span>;
}

export function buildExpenseColumns({ currentPage, pageSize } = {}) {
  return [
    { title: '#', key: '__sno__', width: 56, align: 'center', fixed: 'left',
      render: (_v, _r, idx) => {
        const cp = Number(currentPage) > 0 ? Number(currentPage) : 1;
        const ps = Number(pageSize)    > 0 ? Number(pageSize)    : 25;
        return <span className="erp-grid__muted">{(cp - 1) * ps + idx + 1}</span>;
      } },
    { title: 'Expense No', dataIndex: 'expenseNo', key: 'expenseNo',
      sortField: 'expense_no', sorter: true, width: 160, fixed: 'left',
      render: (v) => v
        ? <code className="erp-grid__code">{v}</code>
        : <span className="erp-grid__muted">—</span> },
    { title: 'Date', dataIndex: 'expenseDate', key: 'expenseDate',
      sortField: 'expense_date', sorter: true, width: 110, dataType: 'date', render: fmtDate },
    { title: 'Category', dataIndex: 'categoryName', key: 'category',
      render: (_v, r) => r.categoryName
        ? <span>
            <code style={{ fontSize: 11, color: '#888', marginRight: 6 }}>{r.categoryCode}</code>
            {r.categoryName}
          </span>
        : <span className="erp-grid__muted">—</span> },
    { title: 'Supplier', dataIndex: 'supplierName', key: 'supplier',
      render: (_v, r) => r.supplierName
        ? <span>
            <code style={{ fontSize: 11, color: '#888', marginRight: 6 }}>{r.supplierCode}</code>
            {r.supplierName}
          </span>
        : <span className="erp-grid__muted">—</span> },
    { title: 'Type', dataIndex: 'expenseType', key: 'expenseType',
      sortField: 'expense_type', width: 100, dataType: 'enum',
      render: (v) => (
        <Tag color={EXPENSE_TYPE_COLOR[v] || 'default'} className="erp-grid__tag">
          {EXPENSE_TYPE_LABEL[v] || v}
        </Tag>
      ) },
    { title: 'Taxable (₹)', dataIndex: 'taxableValue', key: 'taxable',
      width: 130, align: 'right',
      render: (v) => {
        const n = Number(v) || 0;
        return n === 0 ? <span className="erp-grid__muted">—</span> : formatINR(n);
      } },
    { title: 'GST (₹)', key: 'gst', width: 130, align: 'right',
      render: (_v, r) => {
        const tax = (Number(r.cgstAmount) || 0)
          + (Number(r.sgstAmount) || 0)
          + (Number(r.igstAmount) || 0);
        return tax === 0 ? <span className="erp-grid__muted">—</span> : formatINR(tax);
      } },
    { title: 'Total (₹)', dataIndex: 'totalAmount', key: 'totalAmount',
      sortField: 'total_amount', sorter: true, width: 140, align: 'right',
      render: (v) => {
        const n = Number(v) || 0;
        return n === 0 ? <span className="erp-grid__muted">—</span> : <strong>{formatINR(n)}</strong>;
      } },
    { title: 'Payment', dataIndex: 'paymentStatus', key: 'paymentStatus',
      sortField: 'payment_status', width: 100, align: 'center',
      dataType: 'enum',
      render: (v) => (
        <Tag color={PAYMENT_STATUS_COLOR[v] || 'default'} className="erp-grid__tag"
             style={{ marginInlineEnd: 0 }}>
          {PAYMENT_STATUS_LABEL[v] || v}
        </Tag>
      ) },
    { title: 'Status', dataIndex: 'status', key: 'status',
      sortField: 'status', sorter: true, width: 100, align: 'center',
      dataType: 'enum',
      groupable: true, groupField: 'status',
      filters: [
        { text: 'Draft',     value: 'draft' },
        { text: 'Posted',    value: 'posted' },
        { text: 'Cancelled', value: 'cancelled' }
      ],
      filterField: 'status',
      render: (v) => (
        <Tag color={STATUS_COLOR[v] || 'default'} className="erp-grid__tag"
             style={{ marginInlineEnd: 0 }}>
          {(STATUS_LABEL[v] || v || '').toUpperCase()}
        </Tag>
      ) },
    { title: 'Posted At', dataIndex: 'postedAt', key: 'postedAt',
      sortField: 'posted_at', sorter: true, width: 150, dataType: 'date', render: fmtTs }
  ];
}
